import { Typography } from "antd"

import { itemRender } from "../../../../Components/Table"
import { LIST_PAGE_SIZE } from "../../hooks/useCardData"

import styles from "./listPagination.module.less"

const { Text } = Typography

// A list table's class: the platform table's pagination row, its total on the left and Previous /
// Next on the right (Components/Table).
export const listPaginationClass = styles.listPagination

// The platform table's pagination for a list of `useListData` (CHA1-4558): a page of eight rows,
// "Showing 1-8 of 24 results", Previous / Next; none while every row fits on one page.
export const listPagination = ({ data, page, setPage }, t) => {
  if (!data || data.count <= LIST_PAGE_SIZE) return false

  return {
    current: page,
    pageSize: LIST_PAGE_SIZE,
    total: data.count,
    position: ["none", "bottomRight"],
    showLessItems: true,
    showSizeChanger: false,
    itemRender: (_, type, originalElement) => itemRender(_, type, originalElement, t),
    showTotal: (total, range) => (
      <Text>
        Showing <Text strong>{`${range[0]}-${range[1]} of ${total}`}</Text> results
      </Text>
    ),
    onChange: setPage
  }
}
